import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';
import { useUpdateMaterialCostTypeMutation, useGetWarrantyClaimsItemByIdQuery } from '../../../../../../../api';

const MaterialCostTypeDialog = ({ visible, onHide, itemId, onSuccess }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const [materialCostType, setMaterialCostType] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [updateMaterialCostType, { isLoading }] = useUpdateMaterialCostTypeMutation();

    const { data: itemData, isLoading: isLoadingItem, refetch: refetchItem } = useGetWarrantyClaimsItemByIdQuery({ id: itemId, LanguageId: getCurrentLanguageId() }, { skip: !itemId || !visible, refetchOnMountOrArgChange: true });

    useEffect(() => {
        if (visible && itemData?.data) {
            setMaterialCostType(itemData.data.materialCostType || null);
            setSubmitted(false);
        } else if (visible && !itemData) {
            setMaterialCostType(null);
            setSubmitted(false);
        }
    }, [visible, itemData]);

    const handleSend = async () => {
        setSubmitted(true);
        if (!materialCostType) return;

        try {
            await updateMaterialCostType({
                itemId,
                materialCostType
            }).unwrap();
            onSuccess?.();
            onHide();
        } catch (error) {
            console.error('MaterialCostType güncellenirken hata:', error);
        }
    };

    const footer = (
        <div className="flex gap-2 justify-content-end">
            <Button label={th('warrantyClaims.detail.partDialog.cancel')} icon="pi pi-times" onClick={onHide} outlined />
            <Button label={th('warrantyClaims.detail.partDialog.materialCostTypeSend')} icon="pi pi-check" onClick={handleSend} loading={isLoading} />
        </div>
    );

    return (
        <Dialog visible={visible} style={{ width: '30vw' }} header={th('warrantyClaims.detail.partDialog.materialCostType')} modal className="p-fluid" footer={!isLoadingItem ? footer : null} onHide={onHide}>
            {isLoadingItem ? (
                <div className="flex justify-content-center align-items-center py-4">
                    <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                </div>
            ) : (
                <div className="field mb-3">
                    <label className="font-bold block mb-2">{th('warrantyClaims.detail.partDialog.materialCostType')} *</label>
                    <div className="flex gap-4 align-items-center">
                        <div className="flex align-items-center">
                            <RadioButton inputId="materialCostTypeChargeable" name="materialCostType" value={1} onChange={(e) => setMaterialCostType(e.value)} checked={materialCostType === 1} />
                            <label htmlFor="materialCostTypeChargeable" className="ml-2">
                                {th('warrantyClaims.detail.partDialog.materialCostTypeOptions.chargeable')}
                            </label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="materialCostTypeFreeOfCharge" name="materialCostType" value={2} onChange={(e) => setMaterialCostType(e.value)} checked={materialCostType === 2} />
                            <label htmlFor="materialCostTypeFreeOfCharge" className="ml-2">
                                {th('warrantyClaims.detail.partDialog.materialCostTypeOptions.freeOfCharge')}
                            </label>
                        </div>
                    </div>
                    {submitted && !materialCostType && <small className="p-error">{th('warrantyClaims.detail.partDialog.validation.materialCostTypeRequired')}</small>}
                </div>
            )}
        </Dialog>
    );
};

export default MaterialCostTypeDialog;
